import CheckOffIcon from 'components/elements/icons/CheckOffIcon'
import CheckOnIcon from 'components/elements/icons/CheckOnIcon'
import React from 'react'

/**
 * チェックシンボル
 */
const CheckSymbol: React.FC<CheckSymbolProps> = (props) => {
  const CheckIcon = props.isChecked ? CheckOnIcon : CheckOffIcon
  return <CheckIcon width={props.width} height={props.height} />
}

export type CheckSymbolProps = {
  isChecked: boolean
  width?: string
  height?: string
}

export default CheckSymbol
